import { call, put, takeLatest, select } from "redux-saga/effects";
import { PROYECT, api_get, api_put } from "../../services/api";
import { getStations } from "../../helpers/companiesNormalized";
import { getTotal, getPercentage } from "../../helpers/arrayFunctions";
import { openSnackbar } from "./globalSnackbar";

// data
const LOAD_DATA_PIPES_SERIES = "LOAD_DATA_PIPES_SERIES";
const SET_DATA_PIPES_SERIES = "SET_DATA_PIPES_SERIES";
const ERROR_DATA_PIPES_SERIES = "ERROR_DATA_PIPES_SERIES";

// pipes
const LOAD_PIPES_PIPES_SERIES = "LOAD_PIPES_PIPES_SERIES";
const SET_PIPES_PIPES_SERIES = "SET_PIPES_PIPES_SERIES";
const ERROR_PIPES_PIPES_SERIES = "ERROR_PIPES_PIPES_SERIES";

// comments
const SEND_COMMENTS_PIPES_SERIES = "SEND_COMMENTS_PIPES_SERIES";
const SET_COMMENTS_PIPES_SERIES = "SET_COMMENTS_PIPES_SERIES";
const ERROR_COMMENTS_PIPES_SERIES = "ERROR_COMMENTS_PIPES_SERIES";

// filters
const CHANGE_STATION_PIPES_SERIES = "CHANGE_STATION_PIPES_SERIES";
const CHANGE_START_DATE_PIPES_SERIES = "CHANGE_START_DATE_PIPES_SERIES";
const CHANGE_END_DATE_PIPES_SERIES = "CHANGE_END_DATE_PIPES_SERIES";

// config pipes
const LOAD_UNITS_CONFIG_SERIES_SECTION = "LOAD_UNITS_CONFIG_SERIES_SECTION";
const SET_UNITS_CONFIG_SERIES_SECTION = "SET_UNITS_CONFIG_SERIES_SECTION";
const ERROR_UNITS_CONFIG_SERIES_SECTION = "ERROR_UNITS_CONFIG_SERIES_SECTION";

// filters config pipes
const CHANGE_COMPANY_CONFIG_SERIES_SECTION =
  "CHANGE_COMPANY_CONFIG_SERIES_SECTION";
const CHANGE_STATION_CONFIG_SERIES_SECTION =
  "CHANGE_STATION_CONFIG_SERIES_SECTION";

// general
const CLEAR_PIPES_SERIES = "CLEAR_DATA_PIPES_SERIES";
const CLEAR_ERROR_PIPES_SERIES = "CLEAR_ERROR_PIPES_SERIES";
const SET_ERROR_PIPES_SERIES = "SET_ERROR_PIPES_SERIES";

// config
const SET_CONFIG_TAB_PIPES_SERIES = "SET_CONFIG_TAB_PIPES_SERIES";

const INITIAL_STATE = {
  pipes: [],
  pipesAcum: [],
  pipesTotal: 0,
  pipesPercentage: 0,
  companies: [],
  stations: [],
  isLoading: false,
  error: false,
  message: "",
  errorMessage: "",
  isLoadingPipes: false,
  isLoadingComments: false,
  // filters
  startDate: null,
  endDate: null,
  stationSelected: "",
  // filter config pipes
  companyConfigSelected: "",
  stationConfigSelected: "",
  companyConfigStations: [],
  // config pipes
  units: [],
  isLoadingUnits: false,
  // config
  config: {
    tab: 0,
  },
};

const pipesSeriesReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case LOAD_DATA_PIPES_SERIES:
      return {
        ...state,
        pipes: [],
        companies: [],
        stations: [],
        isLoading: true,
        error: false,
        message: "",
        errorMessage: "",
      };
    case SET_DATA_PIPES_SERIES:
      return {
        ...state,
        pipes: payload.pipes,
        companies: payload.companies,
        stations: payload.stations,
        isLoading: false,
      };
    case ERROR_DATA_PIPES_SERIES:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: payload.message,
      };
    case LOAD_PIPES_PIPES_SERIES:
      return {
        ...state,
        pipes: [],
        pipesAcum: [],
        pipesTotal: 0,
        pipesPercentage: 0,
        isLoadingPipes: true,
        error: false,
        message: "",
        errorMessage: "",
      };
    case SET_PIPES_PIPES_SERIES:
      return {
        ...state,
        pipes: payload.pipes,
        pipesAcum: payload.pipesAcum,
        pipesTotal: payload.pipesTotal,
        pipesPercentage: payload.pipesPercentage,
        isLoadingPipes: false,
      };
    case ERROR_PIPES_PIPES_SERIES:
      return {
        ...state,
        isLoadingPipes: false,
        error: true,
        errorMessage: payload.message,
      };
    // comments
    case SEND_COMMENTS_PIPES_SERIES:
      return {
        ...state,
        isLoadingComments: true,
        error: false,
        errorMessage: "",
      };
    case SET_COMMENTS_PIPES_SERIES: {
      const { id } = payload.pipe;
      const newPipes = [...state.pipes];
      const indexRow = newPipes.findIndex((pipe) => pipe.id === id);
      if (indexRow !== -1) {
        newPipes[indexRow].comments = payload.pipe.comments;
      }
      return {
        ...state,
        pipes: newPipes,
        isLoadingComments: false,
      };
    }
    case ERROR_COMMENTS_PIPES_SERIES:
      return {
        ...state,
        isLoadingComments: false,
        error: true,
        errorMessage: payload.message,
      };
    case CHANGE_STATION_PIPES_SERIES:
      return {
        ...state,
        stationSelected: payload,
      };
    case CHANGE_START_DATE_PIPES_SERIES:
      return {
        ...state,
        startDate: payload,
      };
    case CHANGE_END_DATE_PIPES_SERIES:
      return {
        ...state,
        endDate: payload,
      };
    case CLEAR_PIPES_SERIES:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    case CLEAR_ERROR_PIPES_SERIES:
      return {
        ...state,
        error: false,
        errorMessage: "",
      };
    case SET_ERROR_PIPES_SERIES:
      return {
        ...state,
        error: true,
        errorMessage: payload,
      };
    // config pipes
    case LOAD_UNITS_CONFIG_SERIES_SECTION:
      return {
        ...state,
        units: [],
        isLoadingUnits: true,
        error: false,
        errorMessage: "",
      };
    case SET_UNITS_CONFIG_SERIES_SECTION:
      return {
        ...state,
        units: payload.units,
        isLoadingUnits: false,
      };
    case ERROR_UNITS_CONFIG_SERIES_SECTION:
      return {
        ...state,
        isLoadingUnits: false,
        error: true,
        errorMessage: payload.message,
      };
    case CHANGE_COMPANY_CONFIG_SERIES_SECTION:
      return {
        ...state,
        companyConfigSelected: payload.company,
        companyConfigStations: payload.stations,
      };
    case CHANGE_STATION_CONFIG_SERIES_SECTION:
      return {
        ...state,
        stationConfigSelected: payload,
      };
    //config
    case SET_CONFIG_TAB_PIPES_SERIES:
      return {
        ...state,
        config: {
          ...state.config,
          tab: payload,
        },
      };
    default:
      return state;
  }
};

// Actions
function getData() {
  return {
    type: LOAD_DATA_PIPES_SERIES,
  };
}
function getPipes(stations, startDate, endDate) {
  return {
    type: LOAD_PIPES_PIPES_SERIES,
    payload: {
      stations,
      startDate,
      endDate,
    },
  };
}
function changeStation(station) {
  return {
    type: CHANGE_STATION_PIPES_SERIES,
    payload: station,
  };
}
function getUnits(id) {
  return {
    type: LOAD_UNITS_CONFIG_SERIES_SECTION,
    payload: {
      id,
    },
  };
}
function sendCommentsAction(id, body) {
  return {
    type: SEND_COMMENTS_PIPES_SERIES,
    payload: {
      id,
      body,
    },
  };
}
function changeConfigCompany(company, stations) {
  return {
    type: CHANGE_COMPANY_CONFIG_SERIES_SECTION,
    payload: { company, stations },
  };
}
function changeConfigStation(station) {
  return {
    type: CHANGE_STATION_CONFIG_SERIES_SECTION,
    payload: station,
  };
}
function changeStartDate(date) {
  return {
    type: CHANGE_START_DATE_PIPES_SERIES,
    payload: date,
  };
}
function changeEndDate(date) {
  return {
    type: CHANGE_END_DATE_PIPES_SERIES,
    payload: date,
  };
}
function setConfigTab(tab) {
  return {
    type: SET_CONFIG_TAB_PIPES_SERIES,
    payload: tab,
  };
}
function setError(error) {
  return {
    type: SET_ERROR_PIPES_SERIES,
    payload: error,
  };
}
function clearError() {
  return {
    type: CLEAR_ERROR_PIPES_SERIES,
  };
}

// sagas
function* fetchData() {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const url = `${process.env.REACT_APP_URL}${PROYECT}/companies`;
  try {
    const response = yield call(api_get, url, auth);

    const stations = getStations(response.companies);

    const stationsNormalized = stations.map((station) => {
      return { value: station.id, label: station.name };
    });

    yield put({
      type: SET_DATA_PIPES_SERIES,
      payload: {
        companies: response.companies,
        stations: stationsNormalized,
      },
    });
  } catch (message) {
    yield put({
      type: ERROR_DATA_PIPES_SERIES,
      payload: {
        message,
      },
    });
  }
}
function* fetchPipes(action) {
  const {
    payload: { stations = [], startDate, endDate },
  } = action;
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}/units/calibration?`;

  let urlStations = `start=${startDate}&end=${endDate}`;

  if (stations) {
    stations.forEach((station) => {
      urlStations = `${urlStations}&idStation=${station.value}`;
    });
  }
  const url = `${baseUrl}${urlStations}`;

  try {
    const response = yield call(api_get, url, auth);

    const pipesTotal = getTotal(response, "diff");
    const pipesPercentage = getPercentage(response, "percentage");

    let acumPipes = {};
    if (response) {
      response.forEach((pipe) => {
        acumPipes = {
          ...acumPipes,
          [pipe.unit]: {
            idUnit: pipe.idUnit,
            unit: pipe.unit,
            ...acumPipes[pipe.unit],
            capacity: pipe.capacity,
            diffRead:
              acumPipes[pipe.unit] && acumPipes[pipe.unit].diffRead
                ? pipe.readDiff + acumPipes[pipe.unit].diffRead
                : pipe.readDiff,
            diff:
              acumPipes[pipe.unit] && acumPipes[pipe.unit].diff
                ? pipe.diff + acumPipes[pipe.unit].diff
                : pipe.diff,
            percentage: 0,
            comments:
              acumPipes[pipe.unit] && acumPipes[pipe.unit].comments
                ? [...acumPipes[pipe.unit].comments, pipe.comments]
                : [pipe.comments],
          },
        };
      });
    }

    const normalizeAcumPipes = Object.values(acumPipes).map((pipe) => ({
      ...pipe,
      percentage: ((pipe.diff / pipe.diffRead) * 100).toFixed(2),
    }));

    yield put({
      type: SET_PIPES_PIPES_SERIES,
      payload: {
        pipes: response ? response : [],
        pipesAcum: normalizeAcumPipes,
        pipesTotal,
        pipesPercentage: Number.isNaN(pipesPercentage)
          ? 0
          : pipesPercentage.toFixed(2),
      },
    });
  } catch (message) {
    yield put({
      type: ERROR_PIPES_PIPES_SERIES,
      payload: {
        message,
      },
    });
  }
}
function* fetchUnits(action) {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const {
    payload: { id },
  } = action;
  const urlCompanies = `${process.env.REACT_APP_URL}${PROYECT}/units/conf?idStation=${id}`;
  try {
    const response = yield call(api_get, urlCompanies, auth);

    response.sort((act, next) => act.number.localeCompare(next.number));

    yield put({
      type: SET_UNITS_CONFIG_SERIES_SECTION,
      payload: {
        units: response,
      },
    });
  } catch (message) {
    yield put({
      type: ERROR_UNITS_CONFIG_SERIES_SECTION,
      payload: {
        message,
      },
    });
  }
}
function* sendComments(action) {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const {
    payload: { id, body },
  } = action;

  const url = `${process.env.REACT_APP_URL}${PROYECT}/units/calibrations/${id}`;
  try {
    const response = yield call(api_put, url, body, auth);
    yield put({
      type: SET_COMMENTS_PIPES_SERIES,
      payload: {
        pipe: response,
      },
    });
    yield put(openSnackbar("Comentario agregado correctamente", "success"));
  } catch (e) {
    const { data } = e.response;

    let error = "";
    if (e.response.status === 404) {
      error = "Error al enviar la petición.";
    } else {
      error = data ? data.message.error : "Error de datos";
    }
    yield put({
      type: ERROR_COMMENTS_PIPES_SERIES,
      payload: {
        message: error,
      },
    });
  }
}

function* pipesSeriesSaga() {
  yield takeLatest(LOAD_DATA_PIPES_SERIES, fetchData);
  yield takeLatest(LOAD_PIPES_PIPES_SERIES, fetchPipes);
  yield takeLatest(LOAD_UNITS_CONFIG_SERIES_SECTION, fetchUnits);
  yield takeLatest(SEND_COMMENTS_PIPES_SERIES, sendComments);
}

export {
  // reducer
  pipesSeriesReducer,
  // actions
  getData,
  getPipes,
  sendCommentsAction,
  getUnits,
  changeStation,
  changeStartDate,
  changeEndDate,
  changeConfigCompany,
  changeConfigStation,
  setConfigTab,
  setError,
  clearError,
  // saga
  pipesSeriesSaga,
};
